import React from 'react';
import {toAbsoluteUrl} from '../../../_metronic';
import '../../../_metronic/_assets/sass/pages/error/error-404.scss';
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";

export function ErrorContent() {
    return (
        <>
            <div className='kt-grid kt-grid--ver kt-grid--root'>
                <div
                    className='kt-grid__item kt-grid__item--fluid kt-grid kt-error-v1'
                    style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/error/bg1.jpg')})`,
                    }}
                >
                    <div className='kt-error-v1__container text-center'>
                        <h1 className='kt-error-v1__number'>404</h1>
                        <p className='kt-error-v1__desc font-weight-bold'>
                            متاسفانه صفحه مورد نظر یافت نشد
                            می‌توانید با استفاده از لینک زیر به صفحه اصلی بازگردید
                        </p>
                        <Link to="/">
                            <Button>صفحه اصلی</Button>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
